<template>
    <main class="vertical-center-content">
        <section class="section">
            <div class="container text-center">
                <h1>We're sorry,</h1>
                <h3>{{ message }}</h3>
                <p>
                    <a href="/" class="btn btn--secondary">
                        Go to homepage
                    </a>
                </p>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
        },
    },
};
</script>
